import { LocalPizza } from '@mui/icons-material'
import FoodEdit from './FoodEdit'
import FoodCreate from './FoodCreate'
import FoodList from './FoodList'

const foodIndex = {
  icon: LocalPizza,
  list: FoodList,
  edit: FoodEdit,
  create: FoodCreate,
}

export default foodIndex
